import React, { useEffect, useState } from "react";
import { getWork } from "../core/helper/coreapicalls";
import SearchUser from "../core/SearchUser";
import { useNavigate } from "react-router-dom";
import Pagination from "../core/Pagination";

const ITEMS_PER_PAGE = 100; // Adjust as needed

const WorkListUser = () => {
    const navigate = useNavigate();
    const [jobs, setJobs] = useState([]);

    const [error, setError] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);

    const loadingMessage = () => {
        return (
            loading && (
                <div className="overlay">
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="spinner-border text-danger" role="status"></div>
                    </div>
                </div>
            )
        );
    };

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                setLoading(true);
                // const response = await getWork(currentPage);
                const response = await getWork(currentPage, searchQuery);
                const data = Array.isArray(response.results) ? response.results : [];
                setJobs(data);
                setTotalPages(Math.ceil(response.count / ITEMS_PER_PAGE));
                setLoading(false);
            } catch (error) {
                setLoading(false);
                setError(error.message || "An error occurred");
            } finally {
                setLoading(false);
            }
        };
        fetchJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    const handleSort = () => {
        const sortedJobs = [...jobs].sort((a, b) => {
            const dateA = new Date(a.updated_at);
            const dateB = new Date(b.updated_at);
            if (sortOrder === "asc") {
                return dateA - dateB;
            } else {
                return dateB - dateA;
            }
        });
        setJobs(sortedJobs);
        setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    };
    const handleSearch = async (searchTerm) => {
        setSearchQuery(searchTerm);
        try {
            setLoading(true);
            // Reset currentPage to 1 when a new search is initiated
            setCurrentPage(1);
            const response = await getWork(1, searchTerm);
            // Handle empty search results gracefully
            if (response.count === 0) {
                setLoading(false);
                alert("No results found for your search.");
                return;
            }
            // Normalize the response structure if needed (assuming 'results' exists)
            const normalizedResults = Array.isArray(response)
                ? response
                : response.results;
            setJobs(normalizedResults);
            setTotalPages(Math.ceil(response.count / ITEMS_PER_PAGE));
            setLoading(false);

            // setTotalPages(response.count / ITEMS_PER_PAGE);
        } catch (error) {
            setLoading(false);
            alert("Error Searching Works!!");
            console.error("Error searching works:", error);
        }
    };

    const handleAttend = (workId) => {
        // console.log("this is the work is passing:", workId)
        // Navigate to the new page with the corresponding work's ID
        navigate(`/user/create-attendance/${workId}`);
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
    };

    const handlePrevPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };
return (
    <div className="container-fluid px-1">
        {/* Top Controls */}
        <div className="row g-2 mb-2">
            <div className="col-12">
                <SearchUser onSearch={handleSearch} SearchFor="Search Vessel" />
            </div>

            <div className="col-12">
                <button
                    className="btn btn-outline-secondary w-100"
                    onClick={handleSort}
                >
                    {sortOrder === "asc" ? "Sort ⬆️" : "Sort ⬇️"}
                </button>
            </div>
        </div>

        {loading && loadingMessage()}
        {error && <p className="text-danger px-2">Error: {error}</p>}

        {jobs.length > 0 && (
            <>
                {/* Card */}
                <div className="card shadow-sm mx-0">
                    <div className="card-body p-1">
                        <div className="table-responsive">
                            <table className="table table-sm table-striped mb-0 w-100">
                                <thead
                                    className="table-warning"
                                    style={{ fontSize: "11px" }}
                                >
                                    <tr>
                                        <th
                                            className="text-center"
                                            style={{ width: "32px" }}
                                        >
                                            #
                                        </th>
                                        <th>Vessel</th>
                                        <th className="text-nowrap">Job No</th>
                                        <th>PIC</th>
                                        <th
                                            className="text-center"
                                            style={{ width: "60px" }}
                                        >
                                            Action
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {jobs.map((job, index) => (
                                        <tr
                                            key={job.work_id}
                                            style={{ fontSize: "10px" }}
                                        >
                                            {/* Sl No */}
                                            <td className="text-center fw-bold">
                                                {index + 1}
                                            </td>

                                            <td className="text-break">    
                                                <span style={{
                                                    fontSize: "11px",
                                                    lineHeight: "1.2",
                                                    fontWeight: "600",
                                                }}>
                                                    {job.work_vessel}
                                                </span>
                                            </td>

                                            {/* Job No – single line */}
                                            <td className="text-nowrap">
                                                {job.work_job_number}
                                            </td>

                                            {/* PIC – BIGGER & CLEAR */}
                                            <td
                                                style={{
                                                    fontSize: "11px",
                                                    lineHeight: "1.2",
                                                }}
                                                className="text-break"
                                            >
                                                {job.work_job_pic_name}
                                            </td>

                                            {/* Smaller button */}
                                            <td className="text-center">
                                                <button
                                                    className="btn btn-primary"
                                                    style={{
                                                        padding: "1px 4px",
                                                        fontSize: "10px",
                                                    }}
                                                    onClick={() =>
                                                        handleAttend(
                                                            job.work_id
                                                        )
                                                    }
                                                >
                                                    Attend
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Pagination */}
                <div className="mt-2 d-flex justify-content-center">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onNextPage={handleNextPage}
                        onPrevPage={handlePrevPage}
                    />
                </div>
            </>
        )}
    </div>
);



    // return (
    //     <div>
    //         <div className="row ">
    //             <div className="col-6 ">
    //                 <SearchUser onSearch={handleSearch} SearchFor="Search Vessel" />
    //             </div>
    //             <div className="col-4 ">
    //                 <button className="btn   " onClick={handleSort}>
    //                     {sortOrder === "asc" ? "Sort ⬆️" : "Sort ⬇️"}
    //                 </button>
    //             </div>
    //         </div>

    //         {loading && loadingMessage()}
    //         {error && <p>Error: {error}</p>}
    //         {jobs.length > 0 && (
    //             <>
    //                 <div
    //                     className="table-container"
    //                     style={{ maxHeight: "500px", overflowY: "auto" }}
    //                 >
    //                     <table className="table table-striped m-1">
    //                         <thead
    //                             style={{
    //                                 position: "sticky",
    //                                 top: 0,
    //                                 zIndex: 1,
    //                                 background: "yellow ",
    //                             }}
    //                         >
    //                             <tr style={{fontSize:"11px"}}>

    //                                 <th style={{ maxWidth:"30px"}}>Sl.No</th>
    //                                 <th style={{ maxWidth:"50px"}}>Vessel Name</th>
    //                                 <th style={{ maxWidth:"50px"}}>Job No:</th>
    //                                 <th style={{ maxWidth:"50px"}}>PIC</th>
    //                                 <th>Action</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody >

    //                             {jobs.map((job, index) => (
    //                                 <tr key={job.work_id} style={{fontSize:"10px", border:"1px solid black"}}>
    //                                     <th style={{ maxWidth:"30px"}} scope="row">{index + 1}</th>
    //                                     <td style={{ maxWidth:"50px"}}>{job.work_vessel}</td>
    //                                     <td style={{ maxWidth:"50px"}}>{job.work_job_number}</td>
    //                                     <td style={{ maxWidth:"50px"}}>{job.work_job_pic_name}</td>
    //                                     <td>
    //                                         <button
    //                                             className="btn btn-primary badge"
    //                                             onClick={() => handleAttend(job.work_id)}
    //                                         >
    //                                             Attend
    //                                         </button>
    //                                     </td>
    //                                 </tr>
    //                             ))}
    //                         </tbody>
    //                     </table>
    //                 </div>

    //                 {/* Use the Pagination component */}
    //                 <Pagination
    //                     currentPage={currentPage}
    //                     totalPages={totalPages}
    //                     onNextPage={handleNextPage}
    //                     onPrevPage={handlePrevPage}
    //                 />
    //             </>
    //         )}
    //     </div>
    // );
};

export default WorkListUser;
